import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { WorkOrder } from "@/services/backend/htz/work-order/types/work-order";
import { AddPositionDropdown } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/positions/_components/add-position-dropdown";
import { Plus } from "lucide-react";
import { CreateAhuDialog } from "@/services/backend/htz/ahu/components/create-ahu-dialog";
import { Button } from "@/shared/components/ui/button";
import { WorkOrderPositionsTable } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/positions/_components/work-order-positions-table";

export function PositionsCard({ workOrder }: { workOrder: WorkOrder }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Leistungen")}</CardTitle>
        <CardAction className="flex gap-2">
          <CreateAhuDialog
            companyId={workOrder.companyId}
            customerId={workOrder.customerId}
            serviceObjectId={workOrder.serviceObjectId}
            trigger={
              <Button variant="outline" size="sm">
                <Plus />
                {t("RLT-Anlage erstellen")}
              </Button>
            }
          />
          <AddPositionDropdown workOrder={workOrder} />
        </CardAction>
      </CardHeader>
      <CardContent>
        <WorkOrderPositionsTable workOrderId={workOrder.id} />
      </CardContent>
    </Card>
  );
}
